import { Height as Size } from '@atlassian/company-hub-common';

import { type KnowledgeCardsDimensions } from './types';

export const KNOWLEDGE_CARDS_EXTENSION_KEY = 'knowledge-cards';
export const KNOWLEDGE_CARDS_EXTENSION_TYPE = 'com.atlassian.confluence.knowledge-cards';
export const KNOWLEDGE_CARDS_EXTENSION_VERSION_1 = '1.0.0';
export const KNOWLEDGE_CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE = 'knowledgeCardsExtensionConfig';

export const KNOWLEDGE_CARDS_DIMENSIONS: KnowledgeCardsDimensions = {
	[Size.SMALL]: {
		minWidth: 240,
		maxWidth: 294,
		height: 84,
	},
	[Size.MEDIUM]: {
		minWidth: 240,
		maxWidth: 294,
		minHeight: 52,
		maxHeight: 328,
	},
	[Size.LARGE]: {
		minWidth: 326,
		maxWidth: 392,
		minHeight: 64,
		maxHeight: 424,
	},
};
